export enum DealTabIndex {
  Overview = 0,
  Options = 1,
  CriticalDates = 2,
  Deposits = 3,
  LotCommunication = 4,
  CoBuyers = 5,
  DecorConsultant = 6,
  SalesAgents = 7,
  RealtorAgents = 8,
  Documents = 9,
  MiscellaneousDocs = 10,
  incentives = 11,
  OptionsLegacy = 12,
  ReassignBuyer = 13
}
